export const HUD_PALETTES = {
    default: {
        me: null,
        enemy: null,
        hull: '#7ed957',
        hullLow: '#ff4d4f',
        shield: '#6fa8ff',
        energy: '#c3ff5c',
        heat: '#ff8c42',
        ready: '#7ed957',
    },
    deuteranopia: {
        me: '#0072b2',
        enemy: '#e69f00',
        hull: '#56b4e9',
        hullLow: '#f0e442',
        shield: '#cc79a7',
        energy: '#009e73',
        heat: '#d55e00',
        ready: '#56b4e9',
    },
    protanopia: {
        me: '#0072b2',
        enemy: '#e69f00',
        hull: '#56b4e9',
        hullLow: '#f0e442',
        shield: '#cc79a7',
        energy: '#009e73',
        heat: '#d55e00',
        ready: '#56b4e9',
    },
    tritanopia: {
        me: '#d55e00',
        enemy: '#0072b2',
        hull: '#56b4e9',
        hullLow: '#d55e00',
        shield: '#cc79a7',
        energy: '#009e73',
        heat: '#e69f00',
        ready: '#cc79a7',
    },
};
export function hudPalette(name) {
    return HUD_PALETTES[name] ?? HUD_PALETTES['default'];
}
//# sourceMappingURL=palettes.js.map